import { useI18n } from "vue-i18n";
export function useSetLocaleToCacheParams() {
  const { locale } = useI18n();
  function cacheParam(id) {
    return locale.value === "ar" ? "ar_" + id : "en_" + id;
  }
  return {
    cacheParam
  };
}
